(function(){
  var links = Array.prototype.slice.call(document.querySelectorAll('.toc a'));
  var secs = links.map(function(a){ return document.querySelector(a.getAttribute('href')); });
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting){ return; }
        var i = secs.indexOf(e.target);
        links.forEach(function(a, n){ a.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      });
    }, {rootMargin: '-96px 0px -70% 0px'});
    secs.forEach(function(s){ if(s){ obs.observe(s); } });
  }
  links[0].setAttribute('aria-current', 'true');

  var v = document.getElementById('mnv'), snd = document.getElementById('mnsnd');
  var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(v && !still && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ v.play().catch(function(){}); } else { v.pause(); } }); }, {threshold:.4}).observe(v);
  }
  if(snd){ snd.addEventListener('click', function(){ var on = snd.getAttribute('aria-pressed') !== 'true'; v.muted = !on; snd.setAttribute('aria-pressed', on?'true':'false'); if(on){ v.currentTime = 0; v.play().catch(function(){}); } }); }
})();

(function(){ var st=document.getElementById('mstick'), cta=document.querySelector('.mhero .mcta'); if(!st||!cta||!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(es){ es.forEach(function(e){ st.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); st.setAttribute('aria-hidden', st.classList.contains('on')?'false':'true'); }); },{threshold:0}).observe(cta); })();
/* carried over from the live page.menome.liquid */
/* Per-surface attribution: site links arrive as /pages/menome?src=nav|home|footer|blog|chs|quiz.
   Forward the source into the webrail funnel as utm_content (PostHog reads utm_* on both
   surfaces), and keep the App Store ct swap for any badge that ever comes back. */
(function () {
  var src = new URLSearchParams(location.search).get('src');
  if (!src || !/^[a-z_]{1,20}$/.test(src)) return;
  document.querySelectorAll('a[href*="menome.belly-md.com"], a[href*="apps.apple.com"]').forEach(function (a) {
    try {
      var u = new URL(a.href);
      if (u.hostname.indexOf('apps.apple.com') > -1) u.searchParams.set('ct', 'mn_web_evg_' + src);
      else u.searchParams.set('utm_content', src);
      a.href = u.toString();
    } catch (e) {}
  });
})();

